import {HttpClient} from '@angular/common/http';
import {Injectable, Optional} from '@angular/core';
import {ApiService, CsvPropertiesConfirmResponse, CsvPropertiesMapRequest, EnvironmentModel, FileUploadService, SolutionEnvironmentModel} from '@cas-hub/acabim-common-client';
import {NGXLogger} from 'ngx-logger';
import {Observable} from 'rxjs';

export interface SpaceCsvPropertiesConfirmResponse extends CsvPropertiesConfirmResponse {
    readonly projectId: string;
    readonly modelId?: string;
}

@Injectable({
    providedIn: 'root'
})
export class SpaceCsvUpdateService extends ApiService {

    protected controller = 'Space';

    constructor(protected readonly client: HttpClient,
                protected readonly environment: EnvironmentModel,
                private readonly fileUploaderService: FileUploadService,
                @Optional() protected readonly solutionEnvironment?: SolutionEnvironmentModel,
                @Optional() protected readonly logger?: NGXLogger) {
        super(client, environment, solutionEnvironment, logger);
    }

    public startUpdateSession(file: File, onResponse?: (result?: CsvPropertiesMapRequest) => void): Observable<number> {
        const uploadPath = this.controller + '/StartSpacePropertyUpdate';
        return this.fileUploaderService.uploadFile(uploadPath, file, undefined, (body?: any) => {
            if (onResponse) {
                if (body) {
                    onResponse(body as CsvPropertiesMapRequest);
                } else {
                    onResponse(undefined);
                }
            }
        });
    }

    public confirmUpdateSession(confirmation: SpaceCsvPropertiesConfirmResponse): Observable<any> {
        return this.client.post(this.url('ConfirmSpacePropertyUpdate'), confirmation, {
            headers: this.defaultHeaders,
            responseType: 'json'
        });
    }
}
